import * as _ from 'lodash';
import * as ApiWarnings from '../server/ApiWarnings';

angular.module("tromanWeb").factory('DialogControllerBase', ['$q', 'dialogService', function ($q, dialogService) {
    function DialogControllerBase(service, $scope) {

        var isSaving = false;

        $scope.$on('modal.closing', (event, reason, closing) => {
            if (!closing && reason !== 'cancelled') {
                event.preventDefault();
                this.cancel();
            }
        });

        this.getTitle = function () { throw 'Not Implemented'; };
        this.getItem = function () { throw 'Not Implemented'; };

        this.cancel = function cancel() {
            if (this.editForm.$dirty) {
                dialogService.confirm(["Det finns osparade ändringar som kommer gå förlorade.", "Är du säker?"]).then(() => {
                    $scope.$dismiss("cancelled");
                });
            } else {
                $scope.$dismiss("cancelled");
            }
        };

        this.activate = function activate() {
            var item = this.getItem();
            var msg = "Aktivera " + this.getTitle() + ".";

            dialogService.confirm([msg, "Är du säker?"]).then(() => {
                service.activate(item.Id)
                    .then(() => { $scope.$close({ removed: item }); })
                    .catch(err => this.showError(err));
            });
        };

        this.archive = function archive() {
            var item = this.getItem();
            var msg = "Arkivera " + this.getTitle() + ".";

            dialogService.confirm([msg, "Är du säker?"]).then(() => {
                service.archive(item.Id)
                    .then(() => { $scope.$close({ removed: item }); })
                    .catch(err => this.showError(err));
            });
        };

        this.hardRemove = function hardRemove() {
            var msg = "Radera " + this.getTitle() + " permanent.";
            var item = this.getItem();
            dialogService.confirm([msg, "Detta kan inte ångras", "Är du säker?"]).then(() => {
                service.hardRemove(item.Id)
                    .then(() => { $scope.$close({ removed: item }); })
                    .catch(err => this.showError(err));
            });
        };

        this.canSave = function canSave() {
            return !isSaving;
        };

        this.canActivate = function canActivate() {
            return this.editForm.$dirty;
        };

        this.save = function save() {
            this.editForm.$commitViewValue();
            this.editForm.$setSubmitted();

            if (this.editForm.$invalid) return;

            var item = this.getItem();

            isSaving = true;
            if (item.Id == null) {
                service.addEntity(item)
                    .then(rsp => this.checkResponse(rsp))
                    .then(rsp => { $scope.$close({ added: rsp.result }); })
                    .catch(err => this.showError(err))
                    .finally(() => { isSaving = false; });
            } else {
                service.updateEntity(item)
                    .then(rsp => this.checkResponse(rsp))
                    .then(() => { $scope.$close({ updated: item }); })
                    .catch(err => this.showError(err))
                    .finally(() => { isSaving = false; });
            }
        };

        this.checkResponse = function checkResponse(rsp) {
            let warnings = [];

            if (_.has(rsp.warnings, ApiWarnings.PersonHasMultipleMissions)) {
                warnings.push('Personen har överlappande uppdrag.');
            }

            if (_.has(rsp.warnings, ApiWarnings.MissionInGroup)) {
                warnings.push('Uppdraget hör till en plocklista.');
            }

            if (warnings.length > 0) {
                return dialogService.warning(warnings).then(() => rsp).catch(() => rsp);
            }

            return $q.when(rsp);
        };

        this.showError = function showError(err) {
            this.error = err;
        };

        this.loadItem = function loadItem(item) {
            this.isAdding = !(item && item.Id);
            if (this.isAdding) {
                return $q.when(item);
            }
            return service.get(item.Id);
        };
    }

    return DialogControllerBase;
}]);
